import React from "react";
import Rater from "react-rater";

const Review = ({ review }) => (
  <div className="review">
    <div className="review--name-date-star-wrapper">
      <div className="review--name-date">
        <p>{review.name}</p>
        <p className="review-date">{review.date}</p>
      </div>
      <Rater total={5} rating={parseFloat(review.customerRating)} interactive={false} />
    </div>
    <div className="review-comments">
      <p className="review-comments-header">
       Occasion: <strong>{review.purchaseReason}</strong>
      </p>
      <p className="review-comments-body">{review.comment}</p>
    </div>
  </div>
);

export default Review;



// WEBPACK FOOTER //
// ./src/components/CustomerReviews/Review.js